document.addEventListener('DOMContentLoaded', function () {

    function uncheckCheckbox() {
        const checkbox = document.getElementById('header__hamburger');
        if (checkbox && window.innerWidth > 1080) {
            checkbox.checked = false;
        }
    }

    uncheckCheckbox();
    window.addEventListener('resize', uncheckCheckbox);


    var checkboxes = document.querySelectorAll('.arrow-icon-selected');
    checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener('change', function () {
            var closestLi = checkbox.closest('li');
            var submenu = closestLi.nextElementSibling;

            if (submenu && submenu.classList.contains('sub-menu')) {
                submenu.style.display = checkbox.checked ? 'block' : 'none';
            } else {
                console.log('Submenu not found');
            }
        });
    });

    var checkboxInner = document.querySelector('.sub-menu__inner--title .arrow-icon-selected-inner');
    var menuWrapper = document.querySelector('.sub-menu__inner--wrapper');

    if (checkboxInner && menuWrapper) {
        checkboxInner.addEventListener('change', function() {
            menuWrapper.style.display = checkboxInner.checked ? 'block' : 'none';
        });
    } else {
        console.log("Elements for inner checkbox not found");
    }
});